
import { SET_PRELOADED_DATA } from "../Actions/ActionApp";
import { UPDATE_ACCOUNT_INFO } from "../Actions/ActionAccount";
import { Action } from "../../types/Action";
import settings from "settings";
import has from "lodash/has";
import remove from "lodash/remove";
import { APPLICATIONS_CHANGE_ORDER, APPLICATIONS_CHANGE_PAGE, APPLICATIONS_JOIN_CLAN_FETCHING, APPLICATIONS_PROCESSING_FAILED, APPLICATIONS_PROCESSING_SUCCESS, APPLICATIONS_START_PROCESSING, APPLICATIONS_TOGGLE_FETCHING, APPLICATIONS_UPDATE_APPLICATIONS, APPLICATIONS_UPDATE_ERROR, APPLICATIONS_TOGGLE_PLAYER_TICK, APPLICATIONS_TOGGLE_ALL_PLAYERS_TICK, APPLICATIONS_DROP_SELECTION } from "../Actions/ActionApp";

export type State = {
  settings: any;
};

const inititalState = {
  sort: {
    order: 'updated_at',
    isAsc: false
  },
  isFetching: false,
  isFetchingJoinClan: false,
  page: 1,
  applications: [],
  battleTypeSelected: settings.defaultBattleType,
  meta: null,
  error: null,
  idsToProcess: [],
  selectedApplicationsPlayersIds: [],
  settings: {}
};

export type IReducerApp = (state: State, action: Action) => State;
export const ReducerApp = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case SET_PRELOADED_DATA:
      {
        return {
          ...state,
          settings: action.payload.preloadedState
        };
      }
    default:
      return state;

  }
};

export const applications = (state = inititalState, action) => {
  let applications = null;
  let idsToProcess = null;
  let meta = null;
  let newState = null;
  let newSelected = null;

  switch (action.type) {
    case APPLICATIONS_DROP_SELECTION:
      {
        return Object.assign({}, state, {
          selectedApplicationsPlayersIds: []
        });
      }
    case UPDATE_ACCOUNT_INFO:
      if (has(action, 'info.clanId')) {
        return inititalState;
      }

      return state;
    case APPLICATIONS_CHANGE_PAGE:
      return Object.assign({}, state, {
        page: action.page
      });
    case APPLICATIONS_CHANGE_ORDER:
      return Object.assign({}, state, {
        sort: {
          order: action.order,
          isAsc: action.isAsc
        }
      });
    case APPLICATIONS_TOGGLE_FETCHING:
      return Object.assign({}, state, {
        isFetching: !state.isFetching
      });
    case APPLICATIONS_JOIN_CLAN_FETCHING:
      return Object.assign({}, state, {
        isFetchingJoinClan: !state.isFetchingJoinClan
      });
    case APPLICATIONS_UPDATE_APPLICATIONS:
      {
        return Object.assign({}, state, {
          isFetching: false,
          applications: action.data.applications,
          meta: action.data._meta_,
          error: null
        });
      }
    case APPLICATIONS_UPDATE_ERROR:
      return Object.assign({}, state, {
        isFetching: false,
        applications: [],
        meta: null,
        error: action.error
      });
    case APPLICATIONS_START_PROCESSING:
      return Object.assign({}, state, {
        idsToProcess: [...state.idsToProcess, ...action.ids]
      });

    case APPLICATIONS_PROCESSING_SUCCESS:
      {
        idsToProcess = [...state.idsToProcess];
        applications = [...state.applications];

        action.ids.forEach(id => {
          remove(idsToProcess, value => value === id);
          remove(applications, application => application.id === id);
        });

        meta = Object.assign({}, state.meta);
        if (meta && meta.total > 0) {
          meta.total = meta.total - action.ids.length;
        }

        const newSelectedApplicationsPlayersIds = state.selectedApplicationsPlayersIds.filter(item => {
          return state.idsToProcess.indexOf(item) === -1;
        });

        return Object.assign({}, state, {
          applications,
          idsToProcess,
          meta,
          selectedApplicationsPlayersIds: newSelectedApplicationsPlayersIds
        });
      }

    case APPLICATIONS_PROCESSING_FAILED:
      idsToProcess = [...state.idsToProcess];
      action.ids.forEach(id => {
        remove(idsToProcess, value => value === id);
      });
      return Object.assign({}, state, { idsToProcess });

    case APPLICATIONS_TOGGLE_ALL_PLAYERS_TICK:
      newState = Object.assign({}, state);

      if (newState.selectedApplicationsPlayersIds.length === action.selectedApplicationsPlayersIds.length) {
        newState.selectedApplicationsPlayersIds = [];
      } else {
        newState.selectedApplicationsPlayersIds = action.selectedApplicationsPlayersIds;
      }

      return newState;
    case APPLICATIONS_TOGGLE_PLAYER_TICK:
      newState = Object.assign({}, state);
      newSelected = newState.selectedApplicationsPlayersIds.filter(p => p !== action.selectedApplicationsPlayersId);

      if (newSelected.length === newState.selectedApplicationsPlayersIds.length) {
        newSelected.push(action.selectedApplicationsPlayersId);
      }

      newState.selectedApplicationsPlayersIds = newSelected;
      return newState;
    default:
      return state;

  }
};